<template>
  <div class="card" :class="{'ems': $store.state.user.job === 'EMS', 'pemerintah': $store.state.user.job === 'Pemerintah'}">
    <div class="card__container" v-if="!rerenderComponent">
      <div class="grid grid__top">
        <div class="header cell">Nama</div>
        <div class="header cell">Roles</div>
        <div class="header cell">Delete</div>
        <div class="header cell">Reset Password</div>
      </div>
      <div class="grid" v-for="(user, i) in allUser" :key="i">
        <div class="cell">{{user.firstName}} {{user.lastName}}</div>
        <div class="cell">
          <select @change="changeHandler($event, user.id, user.isAdmin)" v-if="$store.state.user.job === 'Pemerintah'">
            <option :selected="user.roleId === 0" :value="0">Staff</option>
            <option :selected="user.roleId === 1" :value="1">Disnaker</option>
            <option :selected="user.roleId === 2" :value="2">Leader</option>
            <option :selected="user.roleId === 3" :value="3">Ajudan</option>
            <option :selected="user.roleId === 4" :value="4">Kepala Dinas</option>
            <option :selected="user.roleId === 5" :value="5">Walikota</option>
          </select>
          <select @change="changeHandler($event, user.id, user.isAdmin)" v-else-if="$store.state.user.job === 'EMS'">
            <option :selected="user.roleId === 6" :value="6">EMT</option>
            <option :selected="user.roleId === 7" :value="7">Trainee</option>
            <option :selected="user.roleId === 8" :value="8">Coass</option>
            <option :selected="user.roleId === 9" :value="9">Dokter Umum</option>
            <option :selected="user.roleId === 10" :value="10">Dokter Spesialis</option>
            <option :selected="user.roleId === 11" :value="11">Laboran</option>
            <option :selected="user.roleId === 12" :value="12">Koordinator SDM</option>
            <option :selected="user.roleId === 13" :value="13">Pimpinan</option>
          </select>
        </div>
        <div class="cell"><div class="delete" @click="deleteHandler(user.id)">Delete</div></div>
        <div class="cell"><div class="reset" @click="resetPasswordHandler(user.id, user.firstName, user.lastName)">Reset Password</div></div>
      </div>
      <div class="form__control form__control--submit">
        <button class="discard fallbackAnimate" :class="{animate: !checkValue}" @click.prevent="discardHandler()">Discard</button>
        <button @click.prevent="submitHandler()">Save</button>
      </div>
    </div>
  </div>
</template>

<script>
  import { message } from 'ant-design-vue';
  import ChangeRoleController from '../../Controller/ChangeRoleController.vue';
  export default {
    extends: ChangeRoleController,
    data() {
      return {
        allUser: [],
        errorMsg: '',
        changes: [],
        rerenderComponent: false,
      }
    },
    mounted() {
      this.getUsers();
    },
    computed: {
      checkValue() {
        return this.changes.length === 0;
      }
    },
    methods: {
      deleteHandler(id) {
        this.deleteUser(id)
          .then(data => {
            if(data.status === 204) {
              this.changes = []
              this.getUsers();
              this.rerender();
            } else {
              this.errorMsg = data.msg;
            }
          })
      },
      submitHandler() {
        if(!this.checkValue) {
          this.updateUser(this.changes)
            .then(data => {
              if(data.status === 201) {
                this.changes = []
                this.getUsers();
                this.rerender();
              } else {
                this.errorMsg = data.msg;
              }
            })
        }
      },
      async rerender() {
        this.rerenderComponent = true;
        await this.$nextTick();
        this.rerenderComponent = false;
      },
      getUsers() {
        this.getAllUser(this.$store.state.user.job)
          .then(data => {
            if(data.msg === undefined) {
              this.allUser = data.result
            } else {
              this.errorMsg = data.msg;
            }
          })
      },
      changeHandler(e, userId) {
        const changeObj = this.checkArrayExist(this.changes, userId)
        if(changeObj) {
          changeObj['roleId'] = parseInt(e.target.value)
        } else {
          this.changes.push({userId, roleId: parseInt(e.target.value)})
        }
      },
      checkArrayExist(arr, userId) {
        const checkUsername = element => element.userId === userId
        return arr.find(checkUsername) 
      },
      async discardHandler() {
        this.changes = [];
        this.rerender();
      },
      resetPasswordHandler(userId, firstName, lastName) {
        console.log(firstName, lastName)
        this.resetPassword(userId)
          .then(data => {
            if(data.msg === undefined) {
              const config = {
                class: 'message-success',
                content: `Berhasil mereset password untuk ${firstName} ${lastName}`,
                duration: 10
              }
              message.success(config)
            } else {
              const config = {
                class: 'message-fail',
                content: `${data.msg} untuk ${firstName} ${lastName}`,
                duration: 10
              }
              message.error(config)
            }
          })
      }
    }
  }
</script>

<style scoped>
  .grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    background: rgb(174, 207, 174);
  }
  .cell {
    padding: 10px;
    border: solid 1px #FFF;
    color: black;
    display: flex;
    overflow-wrap: anywhere;
    justify-content: center;
    align-items: center;
    font-size: 19px;
    height: 100%;
  }

  .ems .cell {
    background: rgba(255, 125, 125, 0.6);
  }

  .ems .cell:first-child {
    color: white;
  }

  .pemerintah .cell {
    background: rgb(174, 207, 174);
  }
  .header {
    color: white;
  }

  .pemerintah .header {
    background: green;
  }

  .ems .header {
    background: rgb(141, 2, 2);
  }

  .ems .grid {
    background: rgba(255, 125, 125, 0.6);
  }



  

  .cell select {
    width: 100%;
    padding: 10px;
    border-radius: 5px;
    font-size: 17px;
  }
  .grid__top {
    margin-top: 20px;
    text-align: center;
  }
  .form__control {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 20px;
    font-size: 18px;
  }

  .delete, .reset {
    background: red;
    padding: 10px;
    border-radius: 5px;
    color: white;
    width: 100px;
    text-align: center;
    cursor: pointer;
  }
  .reset {
    width: 150px;
    background: rgb(47, 47, 117)
  }
  .discard {
    opacity: 0;
    scale: 0;
    transition: all .2s;
  }

  .fallbackAnimate {
    opacity: 0;
    scale: 0;
  }

  .animate {
    opacity: 1;
    scale: 1;
  }
</style>